export const ebookSubcriptionEvent = () => {
    window.fbq('trackCustom', 'cadastroebook')
}
